// removed by extract-text-webpack-plugin
module.exports = {"component":"_1OXaUniXAQ993O1liH71DM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/Templates/Widget/OneClickBuy/oneClickBuy.css
// module id = 1258
// module chunks = 2